module.exports = __webpack_public_path__ + "static/img/zh_HANT1.a416edc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/zh_HANT1.png
// module id = O7aO
// module chunks = 1